/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

const {
  REACT_APP_API_CORE_URL, REACT_APP_API_WEBCHAT_URL, REACT_APP_API_LIVECHAT_URL, REACT_APP_API_REPORTS_URL,
  REACT_APP_GOOGLE_CLIENT_ID, REACT_APP_MICROSOFT_CLIENT_ID, REACT_APP_BUILD_NUMBER, REACT_APP_BUILD_ENV,
  REACT_APP_BRANCH, REACT_APP_MS_BOT_FRAMEWORK_BOT_ID, REACT_APP_LIVECHAT_CONVERSATIONS_ENABLED, REACT_APP_CAROUSEL_NODE_ENABLED,
  REACT_APP_USER_FEEDBACK_ENABLED, REACT_APP_LIVECHAT_REMINDER_ENABLED, REACT_APP_LIVECHAT_TRANSLATION_ENABLED,
  REACT_APP_SCHEDULED_REPORTS_ENABLED, REACT_APP_SUPPORT_EMAIL, REACT_APP_MEDIA_ENABLED, REACT_APP_NOTIFICATIONS_ENABLED, REACT_APP_API_MEDIA_URL,
  REACT_APP_WEBCHAT_DEPLOYMENT_APPLICATION_SETTINGS_ENABLED, REACT_APP_CONTACTS_ENABLED, REACT_APP_DEFAULT_LANGUAGE,
  REACT_APP_HRWIZ_CONSOLE_ENABLED, REACT_APP_HRWIZ_HEADER_DISABLED, REACT_APP_LIVECHAT_ASSISTANT_ENABLED, REACT_APP_HRWIZ_PREFERENCES_BUTTON_DISABLED,
  REACT_APP_HRWIZ_FOOTER_DISABLED, REACT_APP_HRWIZ_SESSION_CONTACTS_DISABLED, REACT_APP_HRWIZ_SESSION_TICKETS_DISABLED, REACT_APP_HRWIZ_SESSION_ANALYSIS_DISABLED,
  REACT_APP_HRWIZ_SESSION_DETAILS_DISABLED, REACT_APP_HRWIZ_SESSION_TAGS_DISABLED, REACT_APP_HRWIZ_SESSION_SEARCH_DROPDOWN_DISABLED, REACT_APP_OFFLINE_TRANSLATIONS_ENABLED,
  REACT_APP_TOPIC_MODELLER_ENABLED, REACT_APP_API_TOPIC_MODELLER_URL, REACT_APP_LOGIN_SCREEN_REDIRECT_DISABLED, REACT_APP_TOPIC_MODELLING_MAX_CHARACTERS_LIMIT,
  REACT_APP_API_MESSENGER_PROFILE_URL, REACT_APP_API_NOTIFICATIONS_URL, REACT_APP_HRWIZ_SHARED_KNOWLEDGE_BASES_HIDDEN, REACT_APP_API_NLP_SERVICE_URL, REACT_APP_CSAT_NODE_ENABLED,
  REACT_APP_ARTICLE_GREEK_OPTIMAL_CHARACTERS_LIMIT, REACT_APP_ARTICLE_GREEK_MAX_CHARACTERS_LIMIT, REACT_APP_ARTICLE_NON_GREEK_OPTIMAL_CHARACTERS_LIMIT,
  REACT_APP_ARTICLE_NON_GREEK_MAX_CHARACTERS_LIMIT, REACT_APP_AUTOMATED_AGENT_TESTING_ENABLED, REACT_APP_API_DATA_MANAGER_URL,
  REACT_APP_CHAT_SESSION_INTERACTION_METADATA_ENABLED, REACT_APP_IS_LIVECHAT_CONSOLE_ONLY, REACT_APP_PRODUCT_VERSION, REACT_APP_ZENDESK_WEB_DEPLOYMENT_ENABLED,
  REACT_APP_API_SCHEDULER_URL,
  REACT_APP_API_KNOWLEDGE_MANAGER_URL,
  REACT_APP_SHAREPOINT_CLIENT_ID,
  REACT_APP_CORS_PROXY_URL
} = process.env;

// API URIs
export const API_CORE_URL = REACT_APP_API_CORE_URL || '';
export const API_WEBCHAT_URL = REACT_APP_API_WEBCHAT_URL || '';
export const API_LIVECHAT_URL = REACT_APP_API_LIVECHAT_URL || '';
export const API_REPORTS_URL = REACT_APP_API_REPORTS_URL || '';
export const API_MEDIA_URL = REACT_APP_API_MEDIA_URL || '';
export const API_NOTIFICATIONS_URL = REACT_APP_API_NOTIFICATIONS_URL || '';
export const API_TOPIC_MODELLER_URL = REACT_APP_API_TOPIC_MODELLER_URL || '';
export const API_NLP_SERVICE_URL = REACT_APP_API_NLP_SERVICE_URL || '';
export const API_MESSENGER_PROFILE_URL = REACT_APP_API_MESSENGER_PROFILE_URL || '';
export const API_DATA_MANAGER_URL = REACT_APP_API_DATA_MANAGER_URL || '';
export const API_SCHEDULER_URL = REACT_APP_API_SCHEDULER_URL || '';
export const API_KNOWLEDGE_MANAGER_URL = REACT_APP_API_KNOWLEDGE_MANAGER_URL || '';

// Keys
// Authentication
export const GOOGLE_CLIENT_ID = REACT_APP_GOOGLE_CLIENT_ID || '';
export const MICROSOFT_CLIENT_ID = REACT_APP_MICROSOFT_CLIENT_ID || '';
export const SHAREPOINT_CLIENT_ID = REACT_APP_SHAREPOINT_CLIENT_ID || '';

// Misc
export const SUPPORT_EMAIL = REACT_APP_SUPPORT_EMAIL || '';
export const DEFAULT_LANGUAGE = REACT_APP_DEFAULT_LANGUAGE || 'en';
export const TOPIC_MODELLING_MAX_CHARACTERS_LIMIT = Number(REACT_APP_TOPIC_MODELLING_MAX_CHARACTERS_LIMIT);
export const ARTICLE_GREEK_OPTIMAL_CHARACTERS_LIMIT = Number(REACT_APP_ARTICLE_GREEK_OPTIMAL_CHARACTERS_LIMIT);
export const ARTICLE_GREEK_MAX_CHARACTERS_LIMIT = Number(REACT_APP_ARTICLE_GREEK_MAX_CHARACTERS_LIMIT);
export const ARTICLE_NON_GREEK_OPTIMAL_CHARACTERS_LIMIT = Number(REACT_APP_ARTICLE_NON_GREEK_OPTIMAL_CHARACTERS_LIMIT);
export const ARTICLE_NON_GREEK_MAX_CHARACTERS_LIMIT = Number(REACT_APP_ARTICLE_NON_GREEK_MAX_CHARACTERS_LIMIT);

// Microsoft Bot Framework
export const MS_BOT_FRAMEWORK_BOT_ID = REACT_APP_MS_BOT_FRAMEWORK_BOT_ID || '';

// Feature flags
export const IS_HRWIZ_CONSOLE_ENABLED = Boolean(Number(REACT_APP_HRWIZ_CONSOLE_ENABLED));
export const IS_HRWIZ_HEADER_DISABLED = Boolean(Number(REACT_APP_HRWIZ_HEADER_DISABLED));
export const IS_HRWIZ_FOOTER_DISABLED = Boolean(Number(REACT_APP_HRWIZ_FOOTER_DISABLED));
export const IS_HRWIZ_SESSION_CONTACTS_DISABLED = Boolean(Number(REACT_APP_HRWIZ_SESSION_CONTACTS_DISABLED));
export const IS_HRWIZ_SESSION_TICKETS_DISABLED = Boolean(Number(REACT_APP_HRWIZ_SESSION_TICKETS_DISABLED));
export const IS_HRWIZ_SESSION_ANALYSIS_DISABLED = Boolean(Number(REACT_APP_HRWIZ_SESSION_ANALYSIS_DISABLED));
export const IS_HRWIZ_SESSION_DETAILS_DISABLED = Boolean(Number(REACT_APP_HRWIZ_SESSION_DETAILS_DISABLED));
export const IS_HRWIZ_SESSION_TAGS_DISABLED = Boolean(Number(REACT_APP_HRWIZ_SESSION_TAGS_DISABLED));
export const IS_HRWIZ_SESSION_SEARCH_DROPDOWN_DISABLED = Boolean(Number(REACT_APP_HRWIZ_SESSION_SEARCH_DROPDOWN_DISABLED));
export const IS_HRWIZ_PREFERENCES_BUTTON_DISABLED = Boolean(Number(REACT_APP_HRWIZ_PREFERENCES_BUTTON_DISABLED));
export const IS_HRWIZ_SHARED_KNOWLEDGE_BASES_HIDDEN = Boolean(Number(REACT_APP_HRWIZ_SHARED_KNOWLEDGE_BASES_HIDDEN));

export const IS_LIVECHAT_CONVERSATIONS_ENABLED = Boolean(Number(REACT_APP_LIVECHAT_CONVERSATIONS_ENABLED));
export const IS_LIVECHAT_REMINDER_ENABLED = Boolean(Number(REACT_APP_LIVECHAT_REMINDER_ENABLED));
export const IS_LIVECHAT_TRANSLATION_ENABLED = Boolean(Number(REACT_APP_LIVECHAT_TRANSLATION_ENABLED));
export const IS_LIVECHAT_ASSISTANT_ENABLED = Boolean(Number(REACT_APP_LIVECHAT_ASSISTANT_ENABLED));
export const IS_LIVECHAT_CONSOLE_ONLY = Boolean(Number(REACT_APP_IS_LIVECHAT_CONSOLE_ONLY));

export const IS_CAROUSEL_NODE_ENABLED = Boolean(Number(REACT_APP_CAROUSEL_NODE_ENABLED));
export const IS_CONTACTS_ENABLED = Boolean(Number(REACT_APP_CONTACTS_ENABLED));
export const IS_MEDIA_MANAGER_ENABLED = Boolean(Number(REACT_APP_MEDIA_ENABLED));
export const IS_NOTIFICATIONS_ENABLED = Boolean(Number(REACT_APP_NOTIFICATIONS_ENABLED));
export const IS_SCHEDULED_REPORTS_ENABLED = Boolean(Number(REACT_APP_SCHEDULED_REPORTS_ENABLED));
export const IS_USER_FEEDBACK_ENABLED = Boolean(Number(REACT_APP_USER_FEEDBACK_ENABLED));
export const IS_WEBCHAT_DEPLOYMENT_APPLICATION_SETTINGS_ENABLED = Boolean(Number(REACT_APP_WEBCHAT_DEPLOYMENT_APPLICATION_SETTINGS_ENABLED));
export const ARE_OFFLINE_TRANSLATIONS_ENABLED = Boolean(Number(REACT_APP_OFFLINE_TRANSLATIONS_ENABLED));
export const IS_TOPIC_MODELLER_ENABLED = Boolean(Number(REACT_APP_TOPIC_MODELLER_ENABLED));
export const IS_LOGIN_SCREEN_REDIRECT_DISABLED = Boolean(Number(REACT_APP_LOGIN_SCREEN_REDIRECT_DISABLED));
export const IS_CSAT_NODE_ENABLED = Boolean(Number(REACT_APP_CSAT_NODE_ENABLED));
export const IS_AUTOMATED_AGENT_TESTING_ENABLED = Boolean(Number(REACT_APP_AUTOMATED_AGENT_TESTING_ENABLED));
export const IS_CHAT_SESSION_INTERACTION_METADATA_ENABLED = Boolean(Number(REACT_APP_CHAT_SESSION_INTERACTION_METADATA_ENABLED));
export const IS_ZENDESK_WEB_MESSENGER_DEPLOYMENT_ENABLED = Boolean(Number(REACT_APP_ZENDESK_WEB_DEPLOYMENT_ENABLED));

// Proxies
export const CORS_PROXY_URL = REACT_APP_CORS_PROXY_URL ?? 'https://corsproxy.io/';

// Build & Versioning info
export const BUILD_NUMBER = REACT_APP_BUILD_NUMBER || '';
export const BUILD_ENV = REACT_APP_BUILD_ENV || '';
export const BRANCH = REACT_APP_BRANCH || '';
export const PRODUCT_VERSION = REACT_APP_PRODUCT_VERSION || '';
